import { Observable } from 'rxjs';
import { Component, OnInit } from '@angular/core';
import { UserService } from '../../services/user.service';
import { AppError, AppErrorService, PageInfo } from 'shared';
import { PageInfoService } from '../../services/page-info.service';
import { AccessClaim } from 'projects/shared/src/lib/interfaces/access';
import { PageErrorHandlerComponent } from '../../../../../shared/src/lib/components/page-error-handler/page-error-handler.component';
import { AsyncPipe } from '@angular/common';
import { PageHeaderComponent } from '../../../../../shared/src/lib/components/page-header/page-header.component';
import { TabsComponent } from '../../../../../shared/src/lib/components/tabs/tabs.component';
import { TabComponent } from '../../../../../shared/src/lib/components/tab/tab.component';
import { ProfilePageComponent } from '../profile-page/profile-page.component';
import { DevicesAndUpgradesComponent } from '../devices-and-upgrades/devices-and-upgrades.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-account-page',
    templateUrl: './account-page.component.html',
    styleUrls: ['./account-page.component.scss'],
    imports: [
    PageErrorHandlerComponent,
    PageHeaderComponent,
    TabsComponent,
    TabComponent,
    ProfilePageComponent,
    DevicesAndUpgradesComponent,
    TranslateModule,
    AsyncPipe
]
})
export class AccountPageComponent implements OnInit {
  public pageInfo: PageInfo;
  public pageError$: Observable<AppError>;
  public deviceManagementAvailable$: Observable<boolean>;

  constructor(private pageInfoService: PageInfoService, private userService: UserService, private errorService: AppErrorService) {}

  ngOnInit(): void {
    this.pageInfo = this.pageInfoService.account();
    this.deviceManagementAvailable$ = this.userService.hasClaim(AccessClaim.CustomerPortalLicenseManagement);
    this.pageError$ = this.errorService.createPageErrorObservable([]);
  }
}
